import React, { useContext } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../../shared/context/auth-context";
import AdminOverview from "./admin/AdminOverview";
import AdminUsersTab from "./admin/AdminUsersTab";
import "./admin/Admin.css";

const TABS = [
  { key: "overview", label: "Overview" },
  { key: "users",    label: "Users" },
];

// /admin/users?tab=overview|users&filter=…&user=<id>
const AdminPage = () => {
  const auth = useContext(AuthContext);
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.key === params.get("tab")) ? params.get("tab") : "overview";

  if (auth.role !== "admin") return <Navigate to="/" replace />;

  return (
    <div className="adm-page">
      <header className="adm-header">
        <h1>Admin</h1>
        <nav className="adm-tabs" aria-label="Admin sections">
          {TABS.map((t) => (
            <button key={t.key} type="button" aria-current={tab === t.key ? "page" : undefined}
                    className={tab === t.key ? "is-active" : ""} onClick={() => setParams({ tab: t.key })}>
              {t.label}
            </button>
          ))}
        </nav>
      </header>

      {tab === "overview" ? (
        <AdminOverview
          auth={auth}
          onOpenUser={(id) => setParams({ tab: "users", user: id })}
          onFilterUsers={(filter) => setParams({ tab: "users", filter })}
        />
      ) : (
        <AdminUsersTab auth={auth} />
      )}
    </div>
  );
};

export default AdminPage;
